import { AutocompleteSource, AutocompleteState, createAutocomplete } from '@algolia/autocomplete-core';
import { AutocompleteQuerySuggestionsHit } from '@algolia/autocomplete-plugin-query-suggestions/dist/esm/types';
import { getAlgoliaResults } from '@algolia/autocomplete-js';
import { type MouseEvent } from 'react';
import algoliaClient from '../../../../algolia-search/algoliaClient';
import { fetchRecentSearches, type RecentSearch } from './recentSearchesHelpers';

type OnStateChange = (state: AutocompleteState<AutocompleteQuerySuggestionsHit>) => void;
type OnSelect = (value: string, sourceId: string) => void;
type RecentSearchesSource = AutocompleteSource<RecentSearch>;

interface AutocompleteProps {
  onSelect: OnSelect;
}

const recentSearchesSource = ({ onSelect }: AutocompleteProps): RecentSearchesSource => (
  {
    sourceId: 'RecentSearches',
    getItems: fetchRecentSearches,
    getItemInputValue: ({ item }) => item.query,
    onSelect: ({ itemInputValue, source }) => onSelect(itemInputValue, source.sourceId),
  }
);

type SuggestionSource = AutocompleteSource<AutocompleteQuerySuggestionsHit>;
interface SuggestionsSourceProps extends AutocompleteProps {
  searchSuggestionIndex: string;
}

const suggestionsSource = ({ onSelect, searchSuggestionIndex }: SuggestionsSourceProps): SuggestionSource => ({
  sourceId: 'QuerySuggestions',
  getItemInputValue: ({ item }) => item.query,
  onSelect: ({ itemInputValue, source }) => onSelect(itemInputValue, source.sourceId),
  getItems: ({ query }) => getAlgoliaResults({
    searchClient: algoliaClient(),
    queries: [
      {
        indexName: searchSuggestionIndex,
        query,
        params: {
          hitsPerPage: 5,
        },
      },
    ],
  }),
});

type AutocompleteBaseItem = AutocompleteQuerySuggestionsHit | RecentSearch;

interface CreateAutocompleteApiProps {
  searchSuggestionIndex: string,
  onStateChange: OnStateChange,
  onSelect: OnSelect,
}

export const createAutocompleteApi = ({
  searchSuggestionIndex,
  onStateChange = () => { },
  onSelect = () => { },
}: CreateAutocompleteApiProps) => createAutocomplete<AutocompleteBaseItem, Event, MouseEvent<HTMLButtonElement>>({
  onStateChange: ({ state }) => {
    // @ts-expect-error
    onStateChange(state);
  },
  openOnFocus: true,
  // @ts-expect-error
  getSources: () => [
    recentSearchesSource({ onSelect }),
    suggestionsSource({
      searchSuggestionIndex,
      onSelect,
    }),
  ],
});
